import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-16 px-6 md:pt-32 md:pb-24 max-w-3xl mx-auto text-center" data-id="element-44">
      <FadeIn data-id="element-45">
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-medium text-charcoal mb-6 leading-tight tracking-tight" data-id="element-46">
          The 72-Hour <br className="hidden md:block" data-id="element-47" />
          <span className="italic text-sage" data-id="element-48">Bloat Protocol</span>
        </h1>
      </FadeIn>

      <FadeIn delay={0.1} data-id="element-49">
        <h2 className="text-xl md:text-2xl font-sans text-charcoal-light mb-12 leading-relaxed max-w-2xl mx-auto font-light" data-id="element-50">
          The "Visual Reset" to flatten your stomach and eliminate the
          3-months-pregnant look before your next event—without expensive
          supplements.
        </h2>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-51">
        <motion.a href="#offer" whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="inline-flex items-center gap-2 px-8 py-4 mb-12 bg-sage hover:bg-sage-dark text-white rounded-full font-sans font-semibold text-lg shadow-[0_0_20px_rgba(107,143,113,0.3)] transition-colors duration-300 cursor-pointer" data-id="element-52">
          Learn More
          <ArrowDownIcon className="w-5 h-5" data-id="element-53" />
        </motion.a>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-54">
        <div className="bg-cream-dark p-8 md:p-10 rounded-2xl text-left border border-sage/10 shadow-sm relative overflow-hidden" data-id="element-55">
          <div className="absolute top-0 left-0 w-1 h-full bg-terracotta" data-id="element-56"></div>
          <p className="text-lg md:text-xl font-serif text-charcoal mb-6 leading-relaxed" data-id="element-57">
            It's 11:00 PM on a Thursday night. You're standing in front of the
            mirror, trying on your outfit for tomorrow, and your heart sinks.
            Your stomach is hard, protruding, and uncomfortable.
          </p>
          <p className="text-lg md:text-xl font-serif text-charcoal leading-relaxed" data-id="element-58">
            You haven't gained five kilos overnight, but you look like you have.
            Your waistband is digging a red line into your skin, and your
            confidence has completely evaporated. You feel heavy, sluggish, and
            betrayed by your own body.
          </p>
        </div>
      </FadeIn>
    </section>;
}